import { Profile } from '@mews-commander/data-access';
import { CoproductElement } from '@mews/std';

export enum ActionLogEntityType {
    Bill = 'Bill',
    OrderItem = 'OrderItem',
}

export enum ActionLogItemDiscriminator {
    ChangeLog = 'ChangeLog',
    Legacy = 'Legacy',
}

interface ChangeObject {
    value: string | null;
    description: string | null;
}

interface ChangeLogItem {
    name: string;
    new: ChangeObject;
    old: ChangeObject;
}
interface LegacyPayloadValue {
    changes: string;
}

interface ChangeLogPayloadValue {
    changes: ChangeLogItem[];
    note?: string;
}

type ActionLogItemChangeLogPayload = CoproductElement<ActionLogItemDiscriminator.ChangeLog, ChangeLogPayloadValue>;
type ActionLogItemLegacyPayload = CoproductElement<ActionLogItemDiscriminator.Legacy, LegacyPayloadValue>;

type ActionLogItemPayload = ActionLogItemChangeLogPayload | ActionLogItemLegacyPayload;

export interface ActionLogItem {
    id: string;
    createdUtc: string;
    entityDescription: string;
    entityId: string;
    profileId: Profile['id'];
    entityType: ActionLogEntityType;
    ownerIds: string[];
    payload: ActionLogItemPayload;
    creatorNameOverride?: string | null;
}
